import { createMuiTheme } from "@material-ui/core";

import colors from "../../shared-styles/colors";

const adminTheme = createMuiTheme({
  /** Set default props for Material UI components  */
  props: {
    MuiTextField: {
      variant: "outlined"
    }
  },
  /** Set a custom color palette */
  palette: {
    primary: {
      light: colors.lightBlue,
      main: colors.deepBlue3,
      dark: colors.deepBlue4
    },
    secondary: { main: colors.accentYellow, light: colors.lightYellow },
    background: {
      default: colors.deepBlue0,
      paper: colors.deepBlue2
    },
    text: {
      primary: colors.white9,
      secondary: colors.lightBlue,
      disabled: colors.white5,
      hint: colors.white7
    }
  },

  /** Set custom typography used throughout the theme
   *  We should stick to these font variants as much as possible throughout
   *  the app and not have a bunch of custom font sizes
   */
  typography: {
    h4: {
      fontSize: "1.5rem",
      fontWeight: 700
    },
    h5: {
      fontSize: "1.2rem",
      fontWeight: 700
    },
    h6: {
      fontSize: "1rem",
      fontWeight: 700
    }
  },

  /** Override styles for every Material UI component that is a child of
   *  the ThemeProvider */
  overrides: {
    MuiButton: {
      root: {
        background: "transparent",
        borderRadius: "2px",
        fontSize: "0.8em",
        fontWeight: "bold",
        textTransform: "none",
        width: "150px"
      },
      contained: {
        backgroundColor: colors.lightBlue,
        border: `2px solid ${colors.lightBlue}`,
        color: colors.white9
      },
      outlined: {
        border: `3px solid ${colors.lightBlue}`
      }
    },
    MuiCard: {
      root: {
        backgroundColor: colors.deepBlue0,
        margin: "5px 0",
        width: "100%"
      }
    },
    MuiCardContent: {
      root: {
        padding: "1.25rem 1.75rem 1.5rem 1.75rem",
        "&:last-child": { paddingBottom: "16px" }
      }
    },
    MuiGrid: {
      root: { flexGrow: 1 },
      item: {
        alignItems: "center",
        display: "flex"
        // width: "100%"
      }
    },
    MuiListItem: {
      root: {
        padding: "0"
      }
    },
    MuiPaper: {
      // root: {
      //   backgroundColor: colors.deepBlue0
      // }
    },
    MuiTab: {
      root: {
        fontWeight: "bolder",
        textTransform: "none"
      }
    },
    MuiTabs: {
      root: {
        fontWeight: 700,
        paddingLeft: "20vw",
        paddingTop: "9vh"
      }
    },
    MuiTextField: {
      root: {
        backgroundColor: colors.deepBlue0
      }
    },
    MuiTypography: {
      root: {
        color: colors.white9
      },
      subtitle1: {
        fontSize: "0.8rem",
        lineHeight: 1.2
      },
      subtitle2: {
        fontSize: "0.8rem",
        margin: "1rem 0",
        lineHeight: 1.2
      }
    }
  }
});

export default adminTheme;
